import * as React from "react";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { PictureAsPdf } from "@material-ui/icons";
import { useNotify } from "react-admin";
import { useAppDataProvider } from "../../dataprovider";

export const ShopReportPdf = ({ record }) => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();

  const shopReportExportToPdf = () => {
    https: dataProvider
      .getShopReportPdfHtml(record?.wo)
      .then((result: any) => {
        const data = result?.data;
        if (!data) {
          notify(`Shop Report Pdf for WO: ${record?.wo} not found!`, { type: "info" });
          return;
        }
        getMatbaaBlobDataAndDownload(decodeHtmlEntities(data));
      })
      .catch(error => {
        console.error(error);
      });
  };

  const decodeHtmlEntities = (encodedString: string) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString("<!doctype html><body>" + encodedString, "text/html");
    return dom.body.textContent;
  };
  const getMatbaaBlobDataAndDownload = html => {
    https: dataProvider
      .getMatbaaBlobData(html)
      .then(response => {
        const data = response.data;
        if (data instanceof Blob) {
          // Creating the blob file and its url
          var blob = new Blob([data], { type: "application/pdf" });
          let url = window.URL.createObjectURL(blob);

          // Creating the hyperlink and auto click it to start the download
          window.open(url); //show in new tab
          let link = document.createElement("a");
          link.href = url;
          link.target = "_blank"; //show in new tab
          link.download = `Shop_Report_Form_${record?.wo}.pdf`;
          document.body.appendChild(link); //show in new tab
          link.click();
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <IconButton style={{ width: 40 }} onClick={shopReportExportToPdf}>
      <Tooltip TransitionComponent={Zoom} title="Shop Report">
        <PictureAsPdf />
      </Tooltip>
    </IconButton>
  );
};

export default ShopReportPdf;
